import { render, staticRenderFns } from "./AddItemToBasketOverlay.vue?vue&type=template&id=71cf7942&"
import script from "./AddItemToBasketOverlay.vue?vue&type=script&lang=js&"
export * from "./AddItemToBasketOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Misha\\Documents\\GitHub\\matrix_varianten\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71cf7942')) {
      api.createRecord('71cf7942', component.options)
    } else {
      api.reload('71cf7942', component.options)
    }
    module.hot.accept("./AddItemToBasketOverlay.vue?vue&type=template&id=71cf7942&", function () {
      api.rerender('71cf7942', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/basket/AddItemToBasketOverlay.vue"
export default component.exports